var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-result-list",
      attrs: {
        title: _vm.popTitle,
        visible: _vm.visibleDialog,
        width: "630px",
        top: "calc(50vh - 350px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "result-con",
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "销售订单号", width: "150" },
              }),
              _vm.type == "tag"
                ? _c("el-table-column", {
                    attrs: { label: "操作结果" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.tagOperationDetails &&
                              scope.row.tagOperationDetails.length > 0
                                ? _vm._l(
                                    scope.row.tagOperationDetails,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        { key: index, staticClass: "line" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.operationType
                                                  ? "开启:"
                                                  : "关闭:"
                                              ) +
                                              " "
                                          ),
                                          item.tagType == 1
                                            ? [
                                                _c("span", {
                                                  class:
                                                    "tag-no tag-" + item.tagId,
                                                }),
                                              ]
                                            : [_vm._v(_vm._s(item.tagName))],
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.failureReason
                                                  ? "（失败 " +
                                                      item.failureReason +
                                                      "）"
                                                  : "（成功）"
                                              ) +
                                              " "
                                          ),
                                        ],
                                        2
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1696905470
                    ),
                  })
                : _vm.type == "publicAudit" || _vm.type == "privateAudit"
                ? _c("el-table-column", {
                    attrs: { label: "操作结果" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.auditResultDesc || "成功") +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  })
                : _vm.type == "setOrderDate"
                ? _c("el-table-column", {
                    attrs: { label: "操作结果" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.failureReason
                                    ? "失败 " + scope.row.failureReason
                                    : "成功"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  })
                : _vm.type == "setLogistics"
                ? _c("el-table-column", {
                    attrs: { label: "操作结果" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.failureReason
                                    ? "失败 " + scope.row.failureReason
                                    : "成功"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.page,
              layout: "total,prev, pager, next, jumper",
              "page-size": _vm.pageSize,
              total: _vm.total,
            },
            on: {
              "current-change": _vm.fetchData,
              "update:currentPage": function ($event) {
                _vm.page = $event
              },
              "update:current-page": function ($event) {
                _vm.page = $event
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }